import React from 'react';
import { ReactComponent as LSQMore } from '../../../../../assets/svgIcons/lsq_more.svg';
// import styles from "./styles.module.css";
import Text from '../../../../../components/Text/index.js';
import { dashboardCardConstants, casaConstants } from '../../../../../constants/globalConstant';
import ConfirmDialog from '../../../../../components/Modal/ConfirmDialog';
import { ReactComponent as DeleteIllustration } from '../../../../../assets/illustrations/delete_illustration.svg';
import { ReactComponent as UpdateIllustration } from '../../../../../assets/illustrations/update_illustration.svg';
import useHomepageCard from '../../hooks/useHomepageCard';
import LsqActionMenu from '../../../../../components/LsqActionMenu';
import { IconButton } from '@lsq/nextgen/v2/button';

export const DashboardCardMenu = ({ items, teamId, homepage, setDialog }) => {
  const {
    publishHomepageClicked,
    unpublishHomepageClicked,
    deleteHomepageClicked,
    unassignHompeageClicked,
    cloneHomepageClicked
  } = useHomepageCard();
  const sourceClicked = dashboardCardConstants.DASHBOARD_CARD;

  const updateDashboard = () => {
    const status = homepage.status;
    if (status === dashboardCardConstants.UNPUBLISHED) {
      publishHomepageClicked(homepage, sourceClicked);
    } else {
      setDialog({
        state: true,
        dialogBox: dialogBox(casaConstants.UNPUBLISH)
      });
    }
  };

  const unpublishDashboard = () => {
    unpublishHomepageClicked(homepage, sourceClicked);
    setDialog({ state: false, dialogBox: {} });
  };

  const deleteHandler = () => {
    deleteHomepageClicked(homepage, sourceClicked);
    setDialog({ state: false, dialogBox: {} });
  };

  const unAssignHandler = () => {
    unassignHompeageClicked(homepage, teamId, sourceClicked);
    setDialog({ state: false, dialogBox: {} });
  };

  const dialogBox = (option) => {
    let displayIcon = <></>;
    let actionLabel = '';
    let clickListener;
    let dashboardName = homepage.name || homepage.homepageName;
    switch (option) {
      case casaConstants.UNPUBLISH:
        displayIcon = <UpdateIllustration />;
        actionLabel = casaConstants.UNPUBLISH;
        clickListener = unpublishDashboard;
        break;
      case casaConstants.DELETE:
        displayIcon = <DeleteIllustration />;
        actionLabel = casaConstants.DELETE;
        clickListener = deleteHandler;
        break;
      case casaConstants.UNASSIGN:
        displayIcon = <UpdateIllustration />;
        actionLabel = casaConstants.UNASSIGN;
        clickListener = unAssignHandler;
        break;
      default:
        break;
    }
    const ConfirmDialogHandler = (e) => {
      clickListener();
      e.stopPropagation();
    };
    return (
      <ConfirmDialog
        setState={setDialog}
        illustration={displayIcon}
        buttonLabel={actionLabel}
        displayText={
          <>
            <Text type="heading" className={`capitalize`} color="rgb(var(--ng-primary-50))">
              {`${actionLabel} ${dashboardName}`}
            </Text>
            <Text type="sub-heading" color="rgb(var(--ng-primary-50))">
              {`Are you sure you want to ${actionLabel} ?`}
            </Text>
          </>
        }
        clickListener={ConfirmDialogHandler}
      />
    );
  };

  const onSelect = (item) => {
    switch (item.value) {
      case casaConstants.CLONE:
        cloneHomepageClicked(homepage, sourceClicked);
        break;
      case casaConstants.PUBLISH:
      case casaConstants.UNPUBLISH:
        updateDashboard();
        break;
      case casaConstants.DELETE:
        setDialog({ state: true, dialogBox: dialogBox(casaConstants.DELETE) });
        break;
      case casaConstants.UNASSIGN:
        setDialog({ state: true, dialogBox: dialogBox(casaConstants.UNASSIGN) });
        break;
      default:
        break;
    }
  };

  // Capitalize the displayed label (e.g. "unpublish" -> "Unpublish") but keep `value` as the
  // original lowercase string, since onSelect switches on it against the casaConstants values.
  const actions = items.map(({ label }) => ({
    label: label.charAt(0).toUpperCase() + label.slice(1),
    value: label
  }));

  return (
    <LsqActionMenu actions={actions} onSelect={onSelect}>
      <IconButton
        data-testid="dashboard-menu"
        icon={<LSQMore />}
        size="xs"
        variant="secondary-gray"
        onClick={(e) => e.stopPropagation()}
      />
    </LsqActionMenu>
  );
};
